import { notifications } from '@mantine/notifications';
export const successMsg = (message) => {
    notifications.show({
        title: "Success",
        message,
        position: 'top-right',
        withCloseButton: true,
        autoClose: 3000,
        color:"green"
      })
};
export const errorMsg = (message) => {
    notifications.show({
        title: "Error",
        message,
        position: 'top-right',
        withCloseButton: true,
        autoClose: 3000,
        color:"red"
      })
};

export const notificationMsg = (message) => {
    notifications.show({
        title: 'Notification',
        message,
        position: 'top-right',
        withCloseButton: true,
        autoClose: 3000,
        color: 'blue',
    });
};
